import React from 'react'
import { WidgetGuard } from 'features/types'
import SideBySideTopicInaccessibleGuard from './SideBySideTopicInaccessibleGuard'
import SideBySideOverComplexGuard from './SideBySideOverComplexGuard'

const PreSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <SideBySideTopicInaccessibleGuard widgetId={widgetId}>
    <SideBySideOverComplexGuard widgetId={widgetId}>{children}</SideBySideOverComplexGuard>
  </SideBySideTopicInaccessibleGuard>
)

export default PreSearchDataGuards
